<template>
  <div>
     <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>定时器管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
  <!-- 搜索与添加区域 -->
    <!-- <collapse @getDataList="getDataList" :button-text="'search'">
        <collapse-item>
        <span class="PlumberCompany" width="300px">查询:</span> 
            <el-input style="width=300px" placeholder="请输入定时器名称或定时器描述去查询" v-model="queryInfoparams.params.keyword" clearable ></el-input>      
        </collapse-item>
   </collapse> -->

    <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="3">
          <el-button-group>
           <el-button  
              plain
              size="small"
              icon="el-icon-plus" @click="showAddDialog">新增</el-button>
          </el-button-group>
        </el-col>
      </el-row>
   <el-table :data="dataList" border stripe>
   <el-table-column type="index" label="No."></el-table-column>
   <el-table-column label="定时器名称" sortable prop="jobName" width="260px"></el-table-column>
   <el-table-column label="定时器组别" sortable prop="jobGroup" width="180px"></el-table-column>
   <el-table-column label="定时器描述" sortable prop="description" width="180px"></el-table-column>
   <el-table-column label="执行时间" sortable prop="cronExpression" width="180px"></el-table-column>
   <el-table-column label="状态" sortable prop="triggerState" width="180px">
      <template slot-scope="scope">
            <el-tag v-if="scope.row.triggerState==='WAITING'" >等待</el-tag>
            <el-tag v-else-if="scope.row.triggerState==='PAUSED'" >暂停</el-tag>
            <el-tag v-else-if="scope.row.triggerState==='ACQUIRED'" >正常执行</el-tag>
            <el-tag v-else-if="scope.row.triggerState==='BLOCKED'" >阻塞</el-tag>
            <el-tag v-else-if="scope.row.triggerState==='ERROR'" >错误</el-tag>
      </template>
   </el-table-column>
   <el-table-column label="operate" width="300px" fixed="right">
<!-- 按钮 -->
        <template slot-scope="scope">
           <div class="btnContainer">
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="showEditDialog(scope.row.jobName,scope.row.jobGroup,scope.row.description,scope.row.cronExpression)" >编辑</el-link> 
             <el-divider direction="vertical"></el-divider>
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="delet(scope.row.jobName,scope.row.jobGroup,scope.row.description,scope.row.cronExpression)" >删除</el-link> 
             <el-divider direction="vertical"></el-divider>
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="recovery(scope.row.jobName,scope.row.jobGroup,scope.row.description,scope.row.cronExpression)" >恢复</el-link>
             <el-divider direction="vertical"></el-divider>
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="stop(scope.row.jobName,scope.row.jobGroup,scope.row.description,scope.row.cronExpression)" >暂停</el-link>
           </div>
        </template>
   </el-table-column>
  </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
 </el-card> 

 <el-dialog title="Please Enter" :visible="dialogVisible" width="50%" @close="dialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="formRef" label-width="70px" >
        <el-row>              
          <el-col :span="12">
               <el-form-item  label="定时器名称" prop="jobName" label-width="160px">
                <el-input :disabled="edit" v-model="addForm.jobName"></el-input>
               </el-form-item>
          </el-col>

           <el-col :span="12">
               <el-form-item  label="组别名称" prop="jobGroup"  label-width="160px">
                  <el-input :disabled="edit" v-model="addForm.jobGroup"></el-input>
               </el-form-item>
           </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item   label-position="left" label="Cron表达式" prop="cronExpression" label-width="160px">
                  <el-input  v-model="addForm.cronExpression" ></el-input>
              </el-form-item>
             </el-col>
              <el-col :span="12">             
                <el-form-item label="备注" prop="description" label-width="160px">
                  <el-input   type="textarea" v-model="addForm.description"></el-input>
                </el-form-item>
            </el-col>  

        </el-row>
      </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="add" type="primary" @click="addQuartz()">保存</el-button>
        <el-button v-if="edit" type="primary" @click="editQuartz()">保存</el-button>
      </span>
    </el-dialog>   

  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
    components:{Collapse,CollapseItem},
    data() {
      return {       
        queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
        },
        dataList: [],
        addForm: {
          jobName:"",
          jobGroup:"",
          description:"",
          cronExpression:""
        },
        dialogVisible:false,
        add:false,
        edit:false

      }
    },
    created(){
        this.getDataList() 
    },
    methods:{

    dialogClosed(){
         this.dialogVisible=false;  
         this.$refs.formRef.resetFields()
      },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

     async getDataList(){
        
          this.$post("scheduler/pageQuery",this.queryInfoparams).then(
          ({ data: res }) => {

            this.dataList = res.records
            this.total = res.total
          }
        )
      },
    showEditDialog(jobName,jobGroup,description,cronExpression){
      debugger
       this.add=false;
       this.edit=true;
       this.dialogVisible=true; 
       this.addForm.jobName=jobName;
       this.addForm.jobGroup=jobGroup;
       this.addForm.description=description;
       this.addForm.cronExpression=cronExpression
    },

    showAddDialog(){
       this.add=true;
       this.edit=false;
       this.dialogVisible=true; 
       this.addForm.jobName="";
       this.addForm.jobGroup="";
       this.addForm.description="";
       this.addForm.cronExpression=""
    },

    delet(jobName,jobGroup,description,cronExpression){
       this.addForm.jobName=jobName;
       this.addForm.jobGroup=jobGroup;
       this.addForm.description=description;
       this.addForm.cronExpression=cronExpression
       this.$post('scheduler/deleteJob',this.addForm).then(
          ({data:res})=>{
           if(res.msg!="删除成功"){
           return this.$message.error('删除定时器失败')
          }
           // 刷新数据列表
          this.getDataList()
          return this.$message.success('删除定时器成功')

          }

       )

    },

    recovery(jobName,jobGroup,description,cronExpression){
       this.addForm.jobName=jobName;
       this.addForm.jobGroup=jobGroup;
       this.addForm.description=description;
       this.addForm.cronExpression=cronExpression
       this.$post('scheduler/resumeJob',this.addForm).then(
          ({data:res})=>{
           if(res.msg!="恢复成功"){
           return this.$message.error('恢复定时器失败')
          }
           // 刷新数据列表
          this.getDataList()
          return this.$message.success('恢复定时器成功')

          }

       )
    },

    stop(jobName,jobGroup,description,cronExpression){

       this.addForm.jobName=jobName;
       this.addForm.jobGroup=jobGroup;
       this.addForm.description=description;
       this.addForm.cronExpression=cronExpression
       this.$post('scheduler/pauseJob',this.addForm).then(
          ({data:res})=>{
           if(res.msg!="暂停成功"){
           return this.$message.error('暂停定时器失败')
          }
           // 刷新数据列表
          this.getDataList()
          return this.$message.success('暂停定时器成功')

          }

       )
    },

    addQuartz(){
     
         this.$post('scheduler/addJob',this.addForm).then(
         ({data:res})=>{
          if(res.msg!="保存成功"){
           return this.$message.error('新增定时器失败')
          }
          this.dialogVisible=false; 
           // 刷新数据列表
          this.getDataList()
          return this.$message.success('新增定时器成功')
         }
        )

       

    },
    editQuartz(){
      debugger
       this.$post('scheduler/updateJob',this.addForm).then(
         ({data:res})=>{
          if(res.msg!="更新成功"){
           return this.$message.error('更新定时器失败')
          }
          this.dialogVisible=false; 
           // 刷新数据列表
          this.getDataList()
          return this.$message.success('更新定时器成功')
         }
        )
    },

    reset(){
       this.queryInfoparams.params.keyword="";
    }
    },

   
}
   
</script>